import { render, staticRenderFns } from "./new-project-button.vue?vue&type=template&id=66ef7a60&"
import script from "./new-project-button.vue?vue&type=script&lang=ts&"
export * from "./new-project-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports